import { render, staticRenderFns } from "./inviteToTeam.vue?vue&type=template&id=61a9d4c6&scoped=true&"
import script from "./inviteToTeam.vue?vue&type=script&lang=js&"
export * from "./inviteToTeam.vue?vue&type=script&lang=js&"
import style0 from "./inviteToTeam.vue?vue&type=style&index=0&id=61a9d4c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a9d4c6",
  null
  
)

export default component.exports